import { mdiClipboardAccountOutline } from '@mdi/js'

export default {
  title: 'Functionary',
  to: 'functionary-school-list',
  icon: mdiClipboardAccountOutline,
  resource: 'FunctionarySchool',
  action: 'read',
}
